import { useEffect, useState } from "react";
import api from "@/lib/api";

const fmtMins = (m) => `${Math.floor((m||0)/60)}h ${(m||0)%60}m`;

export default function Reports() {
  const [tab, setTab] = useState("attendance");
  const [scope, setScope] = useState("weekly");
  const [report, setReport] = useState(null);

  const load = async () => {
    const r = await api.get(`/reports/${tab}?scope=${scope}`);
    setReport(r.data);
  };
  useEffect(() => { load(); }, [tab, scope]);

  const download = () => {
    if (!report) return;
    const rows = report.rows;
    const keys = Object.keys(rows[0] || {});
    const csv = [keys.join(","), ...rows.map(r => keys.map(k => JSON.stringify(r[k] ?? "")).join(","))].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${tab}-${scope}-${report.start}-${report.end}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="border-b border-border px-8 lg:px-12 py-8">
        <div className="eyebrow mb-2">Analytics / Reports</div>
        <h1 className="font-display text-4xl font-black tracking-tight">Reports</h1>
        <p className="text-sm text-muted-foreground mt-2">Aggregate attendance & leave metrics — weekly, monthly, annual.</p>
        <div className="mt-6 flex gap-4 flex-wrap">
          <div className="flex gap-0 border border-border">
            <button onClick={() => setTab("attendance")} className={`px-6 py-2 text-sm font-medium ${tab === "attendance" ? "bg-[#0A0A0A] text-white" : "hover:bg-muted"}`} data-testid="tab-attendance">Attendance</button>
            <button onClick={() => setTab("leaves")} className={`px-6 py-2 text-sm font-medium border-l border-border ${tab === "leaves" ? "bg-[#0A0A0A] text-white" : "hover:bg-muted"}`} data-testid="tab-leaves">Leaves</button>
          </div>
          <div className="flex gap-0 border border-border">
            {["weekly", "monthly", "annual"].map(s => (
              <button key={s} onClick={() => setScope(s)} className={`px-5 py-2 text-sm font-medium capitalize ${scope === s ? "bg-[#002FA7] text-white" : "hover:bg-muted"} ${s !== "weekly" ? "border-l border-border" : ""}`} data-testid={`scope-${s}`}>{s}</button>
            ))}
          </div>
          <button onClick={download} className="border border-[#0A0A0A] px-4 py-2 text-sm font-medium hover:bg-[#0A0A0A] hover:text-white transition-colors" data-testid="download-csv">Download CSV</button>
        </div>
      </div>
      <div className="p-8 lg:p-12">
        {report && (
          <>
            <div className="eyebrow mb-3">{report.start} → {report.end} · {report.rows.length} people</div>
            <div className="border border-border">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border bg-muted">
                    <th className="text-left px-4 py-3 eyebrow">Employee</th>
                    <th className="text-left px-4 py-3 eyebrow">Role</th>
                    {tab === "attendance" ? (
                      <>
                        <th className="text-right px-4 py-3 eyebrow">Days</th>
                        <th className="text-right px-4 py-3 eyebrow">Work</th>
                        <th className="text-right px-4 py-3 eyebrow">Break</th>
                      </>
                    ) : (
                      <>
                        <th className="text-right px-4 py-3 eyebrow">Pending</th>
                        <th className="text-right px-4 py-3 eyebrow">Approved</th>
                        <th className="text-right px-4 py-3 eyebrow">Rejected</th>
                        <th className="text-right px-4 py-3 eyebrow">Total days</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {report.rows.map(r => (
                    <tr key={r.user_id} className="border-b border-border hover:bg-muted/50" data-testid={`report-row-${r.user_id}`}>
                      <td className="px-4 py-3 font-medium">{r.user_name}</td>
                      <td className="px-4 py-3 text-xs uppercase font-mono-mini text-muted-foreground">{r.role}</td>
                      {tab === "attendance" ? (
                        <>
                          <td className="px-4 py-3 text-right font-mono-mini">{r.days}</td>
                          <td className="px-4 py-3 text-right font-mono-mini text-[#002FA7] font-semibold">{fmtMins(r.total_work_minutes)}</td>
                          <td className="px-4 py-3 text-right font-mono-mini text-muted-foreground">{fmtMins(r.total_break_minutes)}</td>
                        </>
                      ) : (
                        <>
                          <td className="px-4 py-3 text-right font-mono-mini text-[#B45309]">{r.pending || 0}</td>
                          <td className="px-4 py-3 text-right font-mono-mini text-[#166534]">{r.approved || 0}</td>
                          <td className="px-4 py-3 text-right font-mono-mini text-[#B91C1C]">{r.rejected || 0}</td>
                          <td className="px-4 py-3 text-right font-mono-mini">{r.total_days}</td>
                        </>
                      )}
                    </tr>
                  ))}
                  {report.rows.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground">No data in this range</td></tr>}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
